import GKCharts from "components/GKCharts";

interface PortfolioBreakdownContentProps {
  data: any;
  onClick?: (clickedElement: any) => void;
  onHover?: (hoveredElement: any) => void;
}

const PortfolioBreakdownContent = (props: PortfolioBreakdownContentProps) => {
  const { data, onClick, onHover } = props;

  const options = {
    chart: {
      type: "pie",
      height: 220,
      width: 220,
    },

    title: {
      text: "",
    },

    tooltip: {
      pointFormat: "",
    },

    plotOptions: {
      pie: {
        innerSize: "0%",
        dataLabels: {
          enabled: false,
        },
        borderColor: "none",
        slicedOffset: 8,
        borderRadius: 0,
        colors: data?.map((d: any) => d.color),
        point: {
          events: {
            click(event: any) {
              onClick && onClick({ ...event.point, id: event.point.name });
            },
            mouseOver(event: any) {
              onHover && onHover({ id: event.target.name });
            },
            mouseOut() {
              onHover && onHover(null);
            },
          },
        },
      },
      series: {
        animation: false,
      },
    },

    series: [
      {
        type: "pie",
        name: "",
        data: data?.map((item: any) => ({
          name: item.id,
          y: item.value,
          color: item.color,
        })),
      },
    ],
    legend: {
      enabled: true,
      align: "right",
      verticalAlign: "bottom",
      layout: "vertical",
      itemStyle: {
        color: "var(--neutral-500)",
      },
      itemHoverStyle: {
        color: "var(--black)",
      },
      symbolHeight: 15,
      symbolWidth: 15,
      symbolRadius: 2,
    },
  };

  return <GKCharts chartOptions={options} />;
};

export default PortfolioBreakdownContent;
